/*
 * PInput should be used as the render component of a Redux Form Input conpoment.
 *
 * Example:  <Field name="quantity" component={PInput} label="Quantity *" validate={required}/>
 */

import React from 'react';
import { Form, Input } from 'semantic-ui-react';
import { PLabel } from '.';
import './forms.css';

export const PInput = ({
    input,
    meta: { touched, warning, error },
    label,
    placeholder,
    name,
    style,
    helpText,
    ...otherProps
}) => (
    <div className="field">
        <Form.Field>
            <PLabel text={label} />

            <Input
                {...otherProps}
                {...input}
                placeholder={placeholder}
                style={style}
            />
            {helpText && (
                <div className="caption-text secondary-color">
                    <i className="icon-Info" /> {helpText}
                </div>
            )}
            {touched &&
                ((error && (
                    <div>
                        <span className="error-text">
                            <i>{error}</i>
                        </span>
                    </div>
                )) ||
                    (warning && (
                        <div>
                            <span className="warning-text">
                                <i>{warning}</i>
                            </span>
                        </div>
                    )))}
        </Form.Field>
    </div>
);
